import { ContentAiIcon } from '@app/modules/content-ai/ContentAiIcon';
import { useIntl } from 'react-intl';
import { Page } from '../../../../../components/page/Page';
import { StationConfigForm } from './StationConfigForm';

export const AdminContentAiPage = () => {
  const { $t } = useIntl();

  const title = $t({
    id: 'contentAi.configTitle',
    defaultMessage: 'Content AI config',
  });

  return (
    <Page htmlTitle={title}>
      <Page.Header icon={<ContentAiIcon />} title={title} />
      <Page.Content>
        <StationConfigForm />
      </Page.Content>
    </Page>
  );
};
